import { useState, useEffect } from 'react';

import { breakpointsNumeric } from '@utilities/constants';

export const useIsResponsiveViewport = (width = breakpointsNumeric.breakpointLg) => {
  const [isResponsiveViewport, setIsResponsiveViewport] = useState(window.innerWidth < width);

  useEffect(() => {
    const handleResize = () => {
      setIsResponsiveViewport(window.innerWidth < width);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [width]);

  return isResponsiveViewport;
};
